import axios, { AxiosError, AxiosResponse } from 'axios'
import config from '@/config'
import alertService from '@/services/alerts/alert.service'
import { IHTTPErrorResponse, IHTTPSuccessResponse } from './http.types'

const AUTH_STORAGE_KEY = 'vk-landing-admin-auth'

const client = axios.create({
  baseURL: config.API_URL,
})

client.interceptors.request.use((requestConfig) => {
  const rawAuth = window.localStorage.getItem(AUTH_STORAGE_KEY) || window.sessionStorage.getItem(AUTH_STORAGE_KEY)
  let token = ''

  try {
    token = rawAuth ? JSON.parse(rawAuth)?.accessToken : ''
  } catch {
    window.localStorage.removeItem(AUTH_STORAGE_KEY)
    window.sessionStorage.removeItem(AUTH_STORAGE_KEY)
  }

  if (token) {
    requestConfig.headers.Authorization = `Bearer ${token}`
  }

  return requestConfig
})

export const handleHttpResponse = <T,>(response: Pick<AxiosResponse<T>, 'data'>): IHTTPSuccessResponse<T> => {
  return { status: 'success', body: response.data }
}

export const handleHttpError = (error: AxiosError): IHTTPErrorResponse => {
  const responseData = error?.response?.data as Record<string, string | string[]> | undefined

  if (error?.response?.status === 400 && responseData) {
    const body: Record<string, string> = {}

    for (const key in responseData) {
      const value = responseData[key]
      body[key] = Array.isArray(value) ? value[0] : value
    }

    return {
      status: 'error',
      message: body.message || 'Отправлены некорректные данные',
      body,
    }
  }

  if ((error?.response?.status || 0) >= 500) {
    alertService.requestAlert({
      type: 'error',
      title: 'Непредвиденная ошибка',
      description: error?.message,
    })
  }

  return {
    status: 'error',
    message: (responseData?.message as string) || error?.message || 'Ошибка при выполнении запроса',
  }
}

export { AUTH_STORAGE_KEY }
export default client
